// extracted by mini-css-extract-plugin
export default {"wrapper":"FileUpload_wrapper__0XGPV","button":"FileUpload_button__05uDb","input":"FileUpload_input__6E8cA","fileName":"FileUpload_fileName__yB0LG"};